import React, { useState } from 'react';
import Avatar from 'react-avatar';
// Utils
import { capitalizeSentence, validArray } from 'utils';
// Context
import { useAuthDispatch } from 'context/AuthContext';
import { initialiseGoogleLogout } from 'context/AuthContext/middleware';
// Elements
import Button from 'elements/Button';
import {
  DrawerGrid,
  DrawerHeader,
  DrawerFooter,
  DrawerContent,
  DrawerLink,
} from 'elements/Drawer';
import { Loading } from 'elements/Loading';

interface ProfileProps {
  avatar: string,
  employeeName: string,
  orgDescription: string,
  userRoles: string[],
}

function Profile({
  avatar,
  employeeName,
  orgDescription,
  userRoles,
}:ProfileProps) {
  const roles = ['Planning Admin', 'Planning', 'Master Data', 'Warehouse'];
  const authDispatch = useAuthDispatch();
  // State
  const [loading, setLoading] = useState(false);
  
  function renderRole(role:string) {
    const activeRole = userRoles.includes(role.toUpperCase());
    return (
      <li key={role}>
        <DrawerLink
          icon={activeRole ? 'Tick' : 'Close'}
          iconBackground={activeRole ? 'fresh-green-100' : 'strawberry-100'}
          iconFill={activeRole ? 'fresh-green' : 'strawberry'}
          label={capitalizeSentence(role.split('_').join(' '))}
        />
      </li>
    );
  }  

  // Handlers
  async function handleLogout() {
    setLoading(true);
    initialiseGoogleLogout(authDispatch);
  }

  return (
    <DrawerGrid>
      <DrawerHeader img>
        <h4 className="display6">{employeeName}</h4>
        <Avatar size="40" round={true} name={employeeName} color="var(--blueberry)" />
      </DrawerHeader>
      <DrawerContent>
        { orgDescription ? (
          <h5 className="subtitle1">{`Your roles at ${orgDescription}`}</h5>
        ) : (
          <h5>No Default Organisation Exists</h5>
        )}
        { validArray(userRoles) ? (
          <ul>
            {roles.map(renderRole)}
          </ul>
        ) : (
          <p>You currently have no roles at this organisation.</p>
        )}        
      </DrawerContent>
      <DrawerFooter>
        { loading ? (
          <Button btnStyle="secondary" btnType="icon">
            <Loading fill="white" size={32} />
          </Button>
        ) : (
          <Button btnStyle="secondary" handler={handleLogout}>
            Logout
          </Button>
        )}
      </DrawerFooter>
    </DrawerGrid>
  );
}

export default Profile;
